<div #wrap class="container-fluid p-3">
    
    <div *ngIf="hidden" class="center">
        <mat-spinner></mat-spinner>
    </div>
    <div [hidden]="hidden" [ngStyle]="{'pointer-events' : hidden ? 'none' : 'all'}">
        <h1 #heading>
            <ng-template app-placeholder></ng-template>
        </h1>
        <div #subcontent class="col-md-12">
            <ng-template app-placeholder></ng-template>
            <button (click)="navigateToDocument(documentID)" mat-flat-button>Zum Dokument</button>
        </div>

        

    </div>
</div>